import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { useHistory } from "react-router-dom";
import { withMainLayout } from "../view/LayoutHOCs";
import BackupSection from "./BackupSection";
import { InfoBoxes } from "../info-boxes/InfoBoxes";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Backups",
        redirectTo: "/backup",
    }
]

function BackupPage({ userCapability }) {

    const history = useHistory();

    //Hide pages with capability = -1, and even if the url is copied then logout the user directly
    //#region Set User Capabilities
    const checkBackupCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "backup" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkBackupCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    useEffect(() => {
        layoutService.setPageTitle('Backups')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            <BackupSection />
        </>

    )

}


function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(BackupPage));